function replaceMediaQuery(query) {
  return query.replace("(width <", "").replace("px)", "");
}
function sortMediaQueries({ media, ...props }) {
  const breakpoints = Object.keys(media);
  const sortedMedia = breakpoints.sort((a, b) => Number(replaceMediaQuery(b)) - Number(replaceMediaQuery(a))).map((query) => ({ query, styles: media[query] }));
  return { ...props, media: sortedMedia };
}

export { replaceMediaQuery, sortMediaQueries };
